import { FormattedMessageWithTooltipHeaderRenderer } from '../../../components/HeaderRenderers';
import { gridNumberFormatter } from '../../../components/ValueFormatters';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn, alwaysVisibleColumnType } from '../../columns';
import * as FIELDS from '../../fields';
import { ACCOUNT_MANAGER_GROUP_REPORT_ID } from './accountManagerGroupReportId';

const columnDefinitions = [
    {
        headerName: FIELDS.ACCOUNT_MANAGER_GROUP.label,
        field: FIELDS.ACCOUNT_MANAGER_GROUP.field,
        type: [leftPinnedColumn, alwaysVisibleColumnType],
    },
    ...[
        FIELDS.SPENT,
        FIELDS.VISIBLE_IMPRESSIONS,
        FIELDS.IMPRESSIONS,
        FIELDS.CLICKS,
        FIELDS.VCTR,
        FIELDS.AVERAGE_CPC,
        FIELDS.VCPM,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.ROAS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        valueFormatter: gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(columnDefinitions, ACCOUNT_MANAGER_GROUP_REPORT_ID);
